import React from 'react';

const Nowrap = ({ children, style, ...rest }) => {
  return (
    <div style={{ whiteSpace: 'nowrap', display: 'inline-block', ...style }} {...rest}>
      {children}
    </div>
  );
};

export default Nowrap;
